import { $getSelection, LexicalEditor } from 'lexical';
import { useTheme } from '@mui/material/styles';
import { $patchStyleText } from '@lexical/selection';

import { MenuItem } from '../../../../../MenuItem';
import { Box } from '../../../../../Box';
import { Typography } from '../../../../../Typography';

export const useBgColorsItems = (
  editor: LexicalEditor,
  activeColor: string,
) => {
  const theme = useTheme();

  const ColorTypeToBlockName = {
    [theme.tokens.colors.bg.light.primary]: 'Белый',
    [theme.tokens.colors.stroke.primary]: 'Серый',
    [theme.tokens.colors.accent.stroke.blue]: 'Синий',
    [theme.tokens.colors.accent.stroke.success]: 'Зеленый',
    [theme.tokens.colors.accent.stroke.warning]: 'Оранжевый',
    [theme.tokens.colors.accent.stroke.error]: 'Красный',
    [theme.tokens.colors.accent.stroke.review]: 'Фиолетовый',
  } as const;

  const applyStyleText = (styles: Record<string, string>) => {
    editor.update(() => {
      const selection = $getSelection();

      if (selection !== null) {
        $patchStyleText(selection, styles);
      }
    });
  };

  const onFontColorSelect = (value: string, type: 'background-color') => {
    applyStyleText({ [type]: value });
  };
  return Object.entries(ColorTypeToBlockName).map(([color, name]) => (
    <MenuItem
      onClick={() => onFontColorSelect(color, 'background-color')}
      key={color}
    >
      <Box display="flex" alignItems="center" gap="8">
        <Box
          width="16px"
          height="16px"
          radius="xs"
          style={{
            backgroundColor: color,
            border: `1px solid ${
              color === theme.tokens.colors.bg.light.primary
                ? theme.tokens.colors.stroke.primary
                : 'transparent'
            }`,
          }}
          border="1px solid"
        />
        <Typography
          variant="body3"
          color={
            activeColor === color
              ? 'original.brand.primary'
              : 'text.light.primary'
          }
        >
          {name}
        </Typography>
      </Box>
    </MenuItem>
  ));
};
